<template>
    <div class="about">
        <MainHeader/>
        <MainLogo/>
        <section style="background: #fff">
	   
              <div class="container margin_60_35">
	<div class="row">
		<div class="col-md-12">
			
			<p>Arturo&#8217;s Pizza and Pasta is committed to keeping your information safe and secure in accordance with the Privacy Act 1988 (Cth) (the “Privacy Act”) and the National Privacy Principles contained therein.</p>
<h3>1 Collection of Personal Information.</h3>
<ul>
<li>1.1 Arturo&#8217;s Pizza and Pasta may collect and use the following kinds of information:
<ul>
<li>(a) Information about your use of the website (including browser type; version and language; operating system; pages viewed while browsing the website; page access times; and referring website address);</li>
<li>(b) Information about your personal details (including name; phone contact details; address information; email; username; password; and payment information); and</li>
<li>(c) Any information necessary to provide services to you (the “Services”).</li>
</ul>
</li>
</ul>
			<hr>
<h3>2 Use and Disclosure of Personal Information.</h3>
<ul>
<li>2.1 Arturo&#8217;s Pizza and Pasta may use your personal information to:
<ul>
<li>(a) enable your access to the Services;</li>
<li>(b) track usage and measure traffic statistics for maintenance of a third party server with respect to the Services;</li>
<li>(c) supply to you the Services;</li>
<li>(d) contact you regarding your use of the Services;</li>
<li>(e) contact you in relation to dispute resolution;</li>
<li>(f) collect payments from you; and</li>
<li>(g) send you marketing communications.</li>
</ul>
</li>
<li>2.2 Arturo&#8217;s Pizza and Pasta will not disclose personal information about you unless is it related to the primary purpose of providing the Services to you.</li>
</ul>
			<hr>
<h3>3 Security and Accuracy</h3>
<ul>
<li>3.1 It is important that you advise Arturo&#8217;s Pizza and Pasta of changes to your personal information as it is essential that your personal information is accurate, complete, and up-to-date in order for Arturo&#8217;s Pizza and Pasta to provide the Services to you.</li>
<li>3.2 Arturo&#8217;s Pizza and Pasta uses reasonable technical precautions and has implemented business processes to protect your personal information from misuse, loss, unauthorised access, modification and disclosure.</li>
<li>3.3 Arturo&#8217;s Pizza and Pasta may disclose your personal information to third parties if you have purchased relevant services which requires third party services.</li>
<li>3.4 Arturo&#8217;s Pizza and Pasta may disclose your personal information to the extent that it is required to do so by law, in connection with any legal proceedings or prospective legal proceedings, and in order to establish, exercise or defend its legal rights.</li>
<li>3.5 Arturo&#8217;s Pizza and Pasta will destroy or permanently de-identify personal information if it is no longer needed for the purposes of providing the Services to you.</li>
</ul>
			<hr>
<h3>4 Access and Correction</h3>
<ul>
<li>4.1 As a customer of Arturo&#8217;s Pizza and Pasta, you can modify or erase the personal information Arturo&#8217;s Pizza and Pasta stores about you. You are responsible to ensure that the information you provide to Arturo&#8217;s Pizza and Pasta is accurate, complete and up-to-date.</li>
</ul>
			<hr>
<h3>5 Identifiers and Anonymity</h3>
<ul>
<li>5.1 Arturo&#8217;s Pizza and Pasta will not identify you based on identifiers that may be given to use via your personal information (I.E Australian Government identifiers (Medicare).</li>
<li>5.2 Arturo&#8217;s Pizza and Pasta provides a personalised service to you as a customer and your name and contact details must be accurate.</li>
</ul>
			<hr>
<h3>6 Trans-border Data Flows</h3>
<ul>
<li>6.1 Arturo&#8217;s Pizza and Pasta will only transfer personal information to someone who is in a foreign country if:
<ul>
<li>(a) Arturo&#8217;s Pizza and Pasta reasonably believes that the recipient of the information is subject to a law, binding scheme or contract which effectively upholds principles for fair handling of the information that are substantially similar to the National Privacy Principles; or</li>
<li>(b) the individual consents to the transfer; or</li>
<li>(c) the transfer is necessary for the performance of a contract between you and Arturo&#8217;s Pizza and Pasta, or for the implementation of pre-contractual measures taken in response to your request; or</li>
<li>(d) the transfer is necessary for the conclusion or performance of a contract concluded in your interest between Arturo&#8217;s Pizza and Pasta and a third party; or</li>
<li>(e) all of the following apply:
<ul>
<li>(i) the transfer is for your benefit;</li>
<li>(ii) it is impracticable to obtain your consent to that transfer; and</li>
<li>(iii) if it were practicable to obtain such consent, you would be likely to give it; or</li>
</ul>
</li>
</ul>
</li>
<li>(f) Arturo&#8217;s Pizza and Pasta has taken reasonable steps to ensure that the information which it has transferred will not be held, used or disclosed by the recipient of the information inconsistently with the National Privacy Principles.</li>
</ul>
			<hr>
<h3>7 Sensitive Information</h3>
<ul>
<li>7.1 Sensitive information is defined in the Privacy Act to include information or opinion about such things as an individual&#8217;s racial or ethnic origin, political opinions, membership of a political association, religious or philosophical beliefs, membership of a trade union or other professional body, criminal record or health information.</li>
<li>7.2 Sensitive information will be used by Arturo&#8217;s Pizza and Pasta only for the primary purpose for which it was obtained; for a secondary purpose that is directly related to the primary purpose; with your consent; or where required or authorised by law.</li>
</ul>
			<hr>
<h3>8 Openness</h3>
<ul>
<li>8.1 By request, you may contact Arturo&#8217;s Pizza and Pasta and ask to know what sort of personal information is held about you, for what purposes, and how it is collected, held, used and disclosed.</li>
</ul>
			<hr>
<h3>9 Updates to this Privacy Policy</h3>
<ul>
<li>9.1 This privacy policy is available for download by clicking the “Privacy Policy” link located at the bottom of this page. Arturo&#8217;s Pizza and Pasta may update<br />
this privacy policy from time to time by posting a new version on its website.</li>
<li>9.2 This policy was last modified on 28 June 2013.</li>
</ul>
			<hr>
<h3>10 Contact</h3>
<ul>
<li>10.1 Please contact Arturo&#8217;s Pizza and Pasta on 02 4574 0884 if you have any questions regarding this Privacy Policy.</li>
</ul>
			
		</div>
	
	</div>
	</div>
   
	   </section>   
    <PopUP/>
    <MainFooter/>

    </div>
     
</template>

<script>
import PreLoader from '@/components/PreLoader.vue'
import MainHeader from '@/components/MainHeader.vue'
import MainLogo from '@/components/MainLogo.vue'
import PopUP from '@/components/Popup.vue'
import MainFooter from '@/components/MainFooter.vue'
export default {
    name: 'privacyPolicy',
     components: {
        PreLoader,
        MainHeader,
        MainLogo,
        PopUP,
        MainFooter
    },
}
</script>

<style>

</style>